import { NgModule } from '@angular/core';

export { NgbOffcanvas } from './offcanvas';
export { NgbOffcanvasConfig, NgbOffcanvasOptions } from './offcanvas-config';
export { NgbOffcanvasRef, NgbActiveOffcanvas } from './offcanvas-ref';
export { OffcanvasDismissReasons } from './offcanvas-dismiss-reasons';

@NgModule({})
export class NgbOffcanvasModule {}
